import { Input, Injectable, Output, EventEmitter, Directive } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CompanyModel } from '@models/CompanyModel';
import { BuyerType, TransactionModel } from '@models/TransactionModel';
import { GiviType, OrderStatus, PointTransactionType } from '@models/Enums';


export class FilterCompanyModel extends CompanyModel {

    public constructor(init?: Partial<Pick<FilterCompanyModel, keyof FilterCompanyModel>>) {
        super();

        if (init) {
            Object.assign(this, init);
        }
    }

    isSelected = false;
}

export interface IFilterSelected {
    searchText: string;
    selectedSorting: string;
    selectedCompanies: FilterCompanyModel[];
}

export interface IFilterPagination {
    page: number;
    pageSize: number;
    pageTotal: number;
}

export class Filter implements IFilterSelected, IFilterPagination {

    public constructor(init?: Partial<Pick<Filter, keyof Filter>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    searchText = '';
    selectedSorting = '';
    selectedCompanies: FilterCompanyModel[] = [];

    page = 1;
    pageSize = 6;
    pageTotal = 0;
}

export class SmartListTransactionItem extends TransactionModel {

    public constructor(init: Partial<TransactionModel & {
        userId: number
    }>) {
        super();

        if (init) {
            Object.assign(this, init);
        }
    }

    userId: number; // Usuario Logueado


    get qrCode(): string {

        if (this.id) {

            /* Rellena el id con ceros a la izquierda para garantizar que tenga al menos 6 caracteres. */
            const code = (this.id.toString()).padStart(6, '0');
            return code;
        }
    }

    get vendorName(): string {

        if (this.vendor) {
            return this.vendor.name;
        }
        return '';
    }

    get vendorURL(): string {

        if (this.vendor) {
            return this.vendor.logoURL;
        }
        return 'assets/images/noimage.png';
    }

    get productURL(): string {

        if (this.product && this.product.images && this.product.images.length) {
            return this.product.images[0].url;
        }
        if (this.giftcard && this.giftcard.images && this.giftcard.images.length) {
            return this.giftcard.images[0].url;
        }
        if (this.coupon) {
            return this.coupon.url;
        }
        if (this.ticket) {
            return this.ticket.productImageAssociate;
        }
        return 'assets/images/noimage.png';
    }

    get giviType(): GiviType {

        let result = GiviType.None;

        if (this.coupon) {
            result = GiviType.CouponUniqueLink
        }
        else if (this.ticket) {
            result = GiviType.Events
        }
        else if (this.giftcard) {
            result = GiviType.Giftcard
        }
        else if (this.product) {
            result = GiviType.Product
        }

        return result;
    }
}


@Injectable()
export abstract class GenericSmartListFilter<T extends IFilterSelected> {

    @Input() showSearch = true;

    @Input() filterTitle: string;

    @Input() filterCompanies: FilterCompanyModel[] = [];

    @Output() onApplyFilter: EventEmitter<T> = new EventEmitter<T>();

    public selected: T;

    constructor(public modalService: NgbModal) {
    }

    openFilterModal(filterModal: any) {

        this.modalService.open(filterModal, {
            backdrop: false, keyboard: false, scrollable: true,
            size: 'lg', windowClass: 'modal-filter modal-full'
        });
    }

    onApplyFilterEvent() {

        this.modalService.dismissAll();
        this.onApplyFilter.emit(this.selected);
    }

    onSearchEvent(text: string) {

        this.selected.searchText = text;
        this.onApplyFilter.emit(this.selected);
    }

    onSelectCompany(event: any) {

        event.preventDefault();

        this.selected.selectedCompanies = this.filterCompanies.filter(x => x.isSelected);
    }
}

@Directive()
@Injectable()
export abstract class GenericSmartList<T> {

    @Input() title = '';

    @Input() source: T[];

    @Input() filter: Filter;

    @Input() showSearch = true;
    @Input() showFilter = true;
    @Input() showPagination = true;

    @Output() onEdit: EventEmitter<T> = new EventEmitter<T>();
    @Output() onView: EventEmitter<T> = new EventEmitter<T>();

    @Output() onFilter: EventEmitter<Filter> = new EventEmitter<Filter>();


    constructor() {

        this.filter = new Filter();
    }

    public onViewEvent(sourceItem: T) {

        this.onView.emit(sourceItem);
    }

    public onPageChange(pageNum: number): void {

        this.filter.page = pageNum;

        this.onFilter.emit(this.filter);
    }

    public onApplyFilterEvent(filter: IFilterSelected) {

        Object.assign(this.filter, filter);

        this.onFilter.emit(this.filter);
    }
}
